// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Supabase project URL and anon key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create Supabase client with automatic refresh enabled
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,     // Automatically saves session in localStorage
    autoRefreshToken: true,   // Automatically refreshes access token when expired
    detectSessionInUrl: true, // Detects OAuth redirects (optional, needed for Google/GitHub login)
  },
});
